import LogoutButton from '../LogoutButton';
import {t} from 'i18next';
import {useUserClaims} from '../../hooks/useUserClaims';
import {BreakpointMinWidth, RoutePath} from '../../lib/enums';
import {useWindowSize} from '@uidotdev/usehooks';
import "./LogoutContainer.css";

export const LogoutContainer = () => {
  const size = useWindowSize();
  const userClaims = useUserClaims();
  return (
    <div id="logout-container">
      {userClaims?.userClaims && (
        <LogoutButton
          style={{height: '100%', width: size.width && size.width < BreakpointMinWidth.xs ? '150px' : '188px'}}
          title={`${t('button.logout')}`}
          returnUrl={RoutePath.LogoutPage}
        />
      )}
    </div>
  );
};
